module.exports = __webpack_public_path__ + "static/media/red-3x.0d8cbb29.png";